import { render, staticRenderFns } from "./UploadBulk.vue?vue&type=template&id=321aa25a&scoped=true&"
import script from "./UploadBulk.vue?vue&type=script&lang=js&"
export * from "./UploadBulk.vue?vue&type=script&lang=js&"
import style0 from "./UploadBulk.vue?vue&type=style&index=0&id=321aa25a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321aa25a",
  null
  
)

export default component.exports